import Handlebars from '@sparta.global.vendors/handlebars';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';
import { link } from '@sparta.global.helpers/link-helper/dist/es6.js';

/* Button Helper */
const UTILITY_NAME = 'helpers/helpers-button-group';
const DEFAULT_BASE_CLASS = 'spa-btn';
const BUTTON_GROUP_BASE_CLASS = 'spa-button-group';
function buttonGroup(configuration, secureHost) {
  let primaryBtnConfigured = false;
  let tertiaryBtnConfigured = false;
  const alignment = configuration.alignment ? configuration.alignment : 'right';
  const config = configuration["buttons"];
  let steps = Object.keys(config);
  let buttonGroup = '';
  let output = '';
  let buttonGroupClasses = '';
  buttonGroupClasses = `class="${BUTTON_GROUP_BASE_CLASS} ${BUTTON_GROUP_BASE_CLASS}--${alignment}${configuration.blockAtMedium ? ` ${BUTTON_GROUP_BASE_CLASS}--block-at-medium` : ''}"`;
  if (!configuration) {
    const msg = `Error in ${UTILITY_NAME}: 'button' HBS helper requires a config object.
        Please check that each object in the HBS template exists in your JCR file.
        If you are using multiple languages ensure all language-based JCRs have the same named objects.`.replace(/\s+/g, ' ');
    throw new Error(msg);
  }
  for (let i = 0; i < steps.length; i++) {
    if (config[i].modifiers) {
      if (config[i].modifiers == "primary") {
        if (primaryBtnConfigured === true) {
          throw new Error(`Error in  ${UTILITY_NAME} ${config[i].content} 'No more than 1 primary is allowed.'`);
        } else {
          primaryBtnConfigured = true;
        }
      } else if (config[i].modifiers == "tertiary") {
        if (tertiaryBtnConfigured === true) {
          throw new Error(`Error in  ${UTILITY_NAME} ${config[i].content} 'No more than 1 tertiary is allowed.'`);
        } else {
          tertiaryBtnConfigured = true;
        }
      }
    }
    const baseExists = Object.prototype.hasOwnProperty.call(config[i], 'base');
    const baseIsValid = baseExists && (config[i].base === '' || config[i].base.length);
    const BASE_CLASS = baseIsValid ? config[i].base : DEFAULT_BASE_CLASS;
    const BTN_PREFIX = `${BASE_CLASS}--`;
    if (config[i].attributes.type === 'link') {
      output = link({
        content: config[i].content,
        modifiers: config[i].modifiers,
        url: config[i].url,
        button: {
          skin: config[i].button.skin,
          size: config[i].button.size
        }
      });
    } else {
      if (config[i].size) {
        config[i].classes = ` ${BTN_PREFIX}${config[i].size}`;
      }
      if (config[i].class) {
        config[i].classes += ` ${config[i].class}`;
      }
      const template = button({
        content: config[i].content,
        modifiers: config[i].modifiers,
        size: config[i].size,
        attributes: {
          id: config[i].attributes.id
        },
        classes: config[i].classes
      });
      output += template;
    }
  }
  buttonGroup = ` <div ${buttonGroupClasses}> ${output} </div>`;

  // output
  return new Handlebars.SafeString(buttonGroup);
}

export { buttonGroup };
